/* eslint-disable flowtype/no-types-missing-file-annotation */
import {connect} from 'react-redux';
import React from 'react';
import {TripBoardConfirmation} from '@homeaway/react-trip-board-button';

import {ListingShape as HitListingShape} from '../Hit/Hit';
// TripBoardConfirmation currently needs to support the same props from State as the heart button
import {mapStateToProps, StateProps} from './TripBoardButton';

type Props = {
    actionLocation: string;
    listing: HitListingShape;
    size?: string;
    isMapHit?: boolean;
} & StateProps;

const TripBoardConfirmationComponent = ({
    actionLocation,
    isMapHit = false,
    isMobile,
    listing: {propertyMetadata, images, listingId, reviewCount, averageRating},
    size
}: Props) => (
    <TripBoardConfirmation
        actionLocation={actionLocation}
        caretOffset={isMobile ? 22 : 26}
        headline={propertyMetadata && propertyMetadata.headline}
        listingId={listingId}
        averageRating={averageRating}
        reviewCount={reviewCount}
        size={size}
        thumbnailUrl={images && images[0] && images[0].c9_uri}
        useNativeEventListener={isMapHit}
    />
);

export default connect(mapStateToProps)(TripBoardConfirmationComponent);
